import React from 'react'
import { useDispatch } from 'react-redux'
import { Formik, Field } from 'formik'

import { Button } from '@/components/buttons/Button'
import { TextInput } from '@/components/forms/TextInput'
import { ErrorMessage } from '@/components/forms/ErrorMessage'
import { BasicModal } from '@/components/layout/modals/BasicModal'
import { updateOrganizationProperties } from '@/reducers/organizations/organization.actions'

export const MultiCallScoringWindowButton = ({
  multiCallScoringWindow,
  organizationId,
  reloadOrganization,
}) => {
  const dispatch = useDispatch()

  const handleSubmit = (values) => {
    if (values.multiCallScoringWindow > 0) {
      dispatch(
        updateOrganizationProperties({
          organizationId,
          reloadOrganization,
          multi_call_scoring_window_days: values.multiCallScoringWindow,
        })
      )
    }
  }

  return (
    <BasicModal
      trigger={(handleOpen) => (
        <Button
          brand
          onClick={handleOpen}
          data-testid="manage-multi-call-scoring-window-button-default"
        >
          Manage Multi Call Scoring
        </Button>
      )}
      title="Multi Call Scoring Window"
    >
      <Formik
        initialValues={{
          multiCallScoringWindow: multiCallScoringWindow || 7,
        }}
        onSubmit={handleSubmit}
        validate={(values) => {
          const errors = {}
          if (!values.multiCallScoringWindow || values.multiCallScoringWindow <= 0) {
            errors.multiCallScoringWindow = 'Must be greater than 0'
          }
          if (values.multiCallScoringWindow > 60) {
            errors.multiCallScoringWindow = 'Must be less than or equal to 60'
          }
          return errors
        }}
      >
        {({ values, errors, touched, handleChange, submitForm }) => (
          <div>
            <div className="flex-align-center small-gap">
              <Field name="multiCallScoringWindow">
                {({ field }) => (
                  <TextInput
                    type="number"
                    min={1}
                    max={60}
                    {...field}
                    value={values.multiCallScoringWindow}
                    onChange={handleChange}
                    placeholder="Enter number > 0"
                    error={touched.multiCallScoringWindow && !!errors.multiCallScoringWindow}
                  />
                )}
              </Field>
              <span>days</span>
            </div>
            {touched.multiCallScoringWindow && errors.multiCallScoringWindow && (
              <ErrorMessage content={errors.multiCallScoringWindow} />
            )}
            <div className="mt">
              <Button brand onClick={submitForm} disabled={!!errors.multiCallScoringWindow}>
                Save
              </Button>
            </div>
          </div>
        )}
      </Formik>
    </BasicModal>
  )
}
